import { DETECTED_ROOT_URL } from "../config/aws-auth"

export function donationOnlyEnabled(flags?: string[]): boolean {
  return flagsInclude("donationOnly", flags)
}

export function teamReportBuilderEnabled(flags?: string[]): boolean {
  return flagsInclude("reportBuilder", flags)
}

export function npoRegDetailsEnabled(flags?: string[]): boolean {
  return flagsInclude("regDetails", flags)
}

export function publicTeamsEnabled(flags?: string[]): boolean {
  return flagsInclude("publicTeam", flags)
}

export function managedFieldTripsEnabled(flags?: string[]): boolean {
  return flagsInclude("managedFieldTrip", flags)
}

export function platformDonationsEnabled(flags?: string[]): boolean {
  return flagsInclude("platformDonations", flags)
}

export function inviteFieldTripEnabled(flags?: string[]): boolean {
  return flagsInclude("inviteFieldTrip", flags)
}

export function isDemoEnv(): boolean {
  return ([
    "http://localhost:3000/",
    "https://heydev.fieldday.com/",
    "https://heydemo.fieldday.com/",
  ].includes(DETECTED_ROOT_URL))
}

// hard-coded for pilots
export const ssoMappings: Record<string, string> = {
  "dynatrace.com": "SSO-Dynatrace",
  "21yktj.onmicrosoft.com": "SSOTestJason",
}

function flagsInclude(flag: string, flags?: string[]): boolean {
  return (flags ?? []).includes(flag)
}
